import React, { useContext, memo } from 'react';
import MenuContext from "./MenuContext";
import { Common } from 'helpers/common';
import { AppContext } from 'context/AppContext';

type Props = {
    children: React.ReactNode, // Add the 'children' property to the 'Props' type
    menus: any[],
}

// This provider is intended to be surrounding the whole application.
// It should receive the users permissions as parameter
const MenuProvider: React.FunctionComponent<Props> = ({ menus, children }) => {

    const { isSystemAdmin } = useContext(AppContext);
    const isAllowedTo = (page: any) => {
        return isSystemAdmin || (menus.some(p => p.menuName === page));
    }
    return <MenuContext.Provider value={{ isAllowedTo }}>{children}</MenuContext.Provider>;
};

export default (MenuProvider);